/**
 * @file Pagination.
 */

/* global FWP */

import { gsap } from 'gsap';
import ScrollTo from 'gsap/ScrollToPlugin';

/**
 * Pagination component.
 */
const vPagination = () => {
	const pagination = document.querySelector('.v-pagination');

	if (!pagination || !FWP) {
		return;
	}

	gsap.registerPlugin(ScrollTo);

	const stickyHeader = document.querySelector('.v-sticky-header');
	const target = document.querySelector('.facetwp-template');

	document.addEventListener('facetwp-refresh', () => {
		if (FWP.soft_refresh === true) {
			FWP.enable_scroll = true;
		} else {
			FWP.enable_scroll = false;
		}
	});

	document.addEventListener('facetwp-loaded', () => {
		if (FWP.enable_scroll === true) {
			gsap.to(window, {
				scrollTo: {
					y:       target,
					offsetY: stickyHeader.getBoundingClientRect().height + 50,
				},
				duration: 0.6,
			});
		}
	});
};

export default vPagination;
